import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ImagilityBaseResponse } from 'app-models';
import { CustomErrorToastComponent } from 'custom-error-toast';
import { ToastrService } from 'ngx-toastr';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MoveToStepService {

constructor(
  private httpClient: HttpClient,
  public toastr: ToastrService
  ) { }

getExistingSteps(taskTypeJsonId: number) {
  return this.httpClient.get(`/vd/pdftoworkflow/fetch/stepJson/${taskTypeJsonId}`)
    .pipe(
      map((response: ImagilityBaseResponse) => {
        if (response && [200, 204].includes(response.status)) {
          return response;
        } else {
          CustomErrorToastComponent.showErrorToast(this.toastr, response.message);
          return null;
        }
      })
    );
}



}
